import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { TableScrollTop } from '../../directives/table-scroll-top';

@Component({
  selector: 'app-mubadala-abu-dhabi-open-privacy-notice',
  imports: [TableScrollTop],
  templateUrl: './mubadala-abu-dhabi-open-privacy-notice.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mubadala-abu-dhabi-open-privacy-notice.scss',
})
export class MubadalaAbuDhabiOpenPrivacyNotice {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle =
    'Mari Group – Mubadala Abu Dhabi Open Privacy Notice';
  protected readonly seoDescription =
    'Read the Mubadala Abu Dhabi Open Privacy Notice, covering the Personal Information AE EventsCo Holdings LLC collects from ticket buyers, event attendees, and website visitors, and how it is used, shared, transferred, retained, and protected.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy', path: '/privacy' },
        {
          name: 'Mubadala Abu Dhabi Open Privacy Notice',
          path: '/mubadala-abu-dhabi-open-privacy-notice',
        },
      ],
    });
  }
}
